/**
 * Check if component is out of screen, and get coordinates to reposition it.
 * Used for fixed popup components.
 *
 * @param {String} component - the html component
 * @returns top and left positions
 */
export const checkComponentPositionOutOfScreen = (component, margin = 40) => {
  const rect = component.getBoundingClientRect()
  const isWidthOut = rect.x + rect.width > window.innerWidth
  let leftPosition = rect.x
  let topPosition = rect.y
  const MARGIN = margin
  if (isWidthOut) {
    leftPosition =
      leftPosition - (rect.x + rect.width - window.innerWidth + MARGIN)
  }
  const isHeightOut = rect.y + rect.height > window.innerHeight

  if (isHeightOut) {
    topPosition =
      topPosition - (rect.y + rect.height - window.innerHeight + MARGIN)
  }

  return { top: topPosition, left: leftPosition }
}

export const isComponentOutOfScren = component => {
  const rect = component.getBoundingClientRect()
  const position = { left: false, top: false }
  const isWidthOut = rect.x + rect.width > window.innerWidth
  if (isWidthOut) {
    position.left = true
  }
  const isHeightOut = rect.y + rect.height > window.innerHeight
  if (isHeightOut) {
    position.top = true
  }

  return position
}

/**
 * Get caret screen coodinates of editable content
 * @returns
 */
export const getCaretTopPoint = () => {
  const sel = document.getSelection()
  const r = sel.getRangeAt(0)
  let rect
  let r2
  // supposed to be textNode in most cases
  // but div[contenteditable] when empty
  const node = r.startContainer
  const offset = r.startOffset
  if (offset > 0) {
    // new range, don't influence DOM state
    r2 = document.createRange()
    r2.setStart(node, offset - 1)
    r2.setEnd(node, offset)
    // https://developer.mozilla.org/en-US/docs/Web/API/range.getBoundingClientRect
    // IE9, Safari?(but look good in Safari 8)
    rect = r2.getBoundingClientRect()
    return { left: rect.right, top: rect.top }
  } else if (offset < node.length) {
    r2 = document.createRange()
    // similar but select next on letter
    r2.setStart(node, offset)
    r2.setEnd(node, offset + 1)
    rect = r2.getBoundingClientRect()
    return { left: rect.left, top: rect.top }
  } // textNode has length
  // https://developer.mozilla.org/en-US/docs/Web/API/Element.getBoundingClientRect
  rect = node.getBoundingClientRect()
  const styles = getComputedStyle(node)
  const lineHeight = parseInt(styles.lineHeight)
  const fontSize = parseInt(styles.fontSize)
  // roughly half the whitespace... but not exactly
  const delta = (lineHeight - fontSize) / 2
  return { left: rect.left, top: rect.top + delta }
}
